
export const initialValues = {
  subzoneName: "",
  zoneId: "",
  districtId: "",
  activeStatus: 1,

}